import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useResource from 'Hooks/useResource';
import MetaFormFieldList from '../Meta/MetaForm/Components/MetaFormFieldList';

const styles = () => ({
  root: {},
});


const PredefinedTaskChecklist = ({
  classes,
  taskResource,
  setTaskSetResource,
}) => {
  const { resource, setAttribute } = useResource(taskResource);
  const onTaskChange = (attrName, value) => {
    setAttribute(attrName, value);
    setTaskSetResource('predefinedTasks', resource.parent().parentInstance);
  };

  return (
    <MetaFormFieldList
      className={classes.root}
      resource={resource}
      onChange={onTaskChange}
    />
  );
};

PredefinedTaskChecklist.propTypes = {
  classes: PropTypes.object.isRequired,
  taskResource: PropTypes.object.isRequired,
  setTaskSetResource: PropTypes.func.isRequired,
};

export default withStyles(styles)(PredefinedTaskChecklist);
